import { useCallback } from 'react';
import { multiCurrencyCache } from '../../cache';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
export const useHomeCurrency = () => {
  const httpClient = useHttpClient();
  const getHomeCurrency = useCallback(() => {
    return multiCurrencyCache.get('', httpClient).then(response => {
      var _response$homeCurrenc;
      return (_response$homeCurrenc = response.homeCurrency) === null || _response$homeCurrenc === void 0 ? void 0 : _response$homeCurrenc.currencyCode;
    });
  }, [httpClient]);
  return useAsyncFunction(getHomeCurrency);
};